 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		14: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		14: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"cb1608f2","2":"styles","3":"44bb9f082193e74168b5135406bf08e32ffb53da","4":"8ccc3ce12924ac33615472e4ecd356ae2961a461","5":"78a9dc6c6428b20d65f489544773ccf386654ce8","6":"5c16e5b16666b7d1dded8a145e379ee02da2efbe","7":"d9c241b54393082e9b9d8418b075aa22f071953c","8":"fcb1787550e3506b9a5b22862ab5d9efe82f78fe","9":"30eb79519e100eace5766eaea1288fe5195dc727","10":"963fcfe0cb6db8fb67219de76b409abdfaf5b68d","11":"ac1c44fc","12":"b6689b9f52a193071338daafc1aa2738f916e04f","13":"c27ef261a850dd77219473b0b3b25ad516ed7add","15":"532a2f07","17":"component---src-pages-404-js","18":"component---src-pages-about-us-js","19":"component---src-pages-bs-404-js","20":"component---src-pages-bs-hvala-vam-js","21":"component---src-pages-bs-impresum-js","22":"component---src-pages-bs-index-js","23":"component---src-pages-bs-kontakt-js","24":"component---src-pages-bs-konzalting-js","25":"component---src-pages-bs-o-nama-js","26":"component---src-pages-bs-reference-js","27":"component---src-pages-bs-well-karijera-js","28":"component---src-pages-consulting-js","29":"component---src-pages-contact-js","30":"component---src-pages-impresum-js","31":"component---src-pages-index-js","32":"component---src-pages-references-js","33":"component---src-pages-thankyou-js","34":"component---src-pages-well-careers-js","35":"component---src-templates-blog-js","36":"component---src-templates-blog-post-js","37":"component---src-templates-bs-blog-js","38":"component---src-templates-bs-blog-post-bs-js","39":"component---src-templates-bs-digitalni-marketing-js","40":"component---src-templates-bs-graficki-dizajn-js","41":"component---src-templates-bs-online-trgovina-js","42":"component---src-templates-bs-portfolio-js","43":"component---src-templates-bs-portfolio-post-bs-js","44":"component---src-templates-bs-video-oglasavanje-js","45":"component---src-templates-bs-web-dizajn-js","46":"component---src-templates-digital-marketing-js","47":"component---src-templates-graphic-design-js","48":"component---src-templates-online-store-js","49":"component---src-templates-portfolio-js","50":"component---src-templates-portfolio-post-js","51":"component---src-templates-video-advertisment-js","52":"component---src-templates-web-design-js"}[chunkId]||chunkId) + "-" + {"0":"d30bd995ff500a6971b4","1":"8204bc4932243a1e1190","2":"f3e9059f8c2a75df70f2","3":"c5454b6bdc93ece0a2bd","4":"78e7d4ac21a799cf103c","5":"cbaae1c13cd1c4113576","6":"e738e6a7d2f571ba789d","7":"1e2fef24397e39d5ccc1","8":"823828245cf3f0c48d79","9":"85167e967729c7f790a2","10":"a8da9f81754985f356a0","11":"1e34c7b1d6acf563325a","12":"ee953fbf3be66e3c8a59","13":"33b68d34852766275e15","15":"4611eea46f4452ce0aa8","17":"f3c953008e17e0b9794c","18":"41b66190e5b8d0a187e8","19":"5c1428a687411d3bd7b2","20":"6ff421392c53c0ae7c2f","21":"6f9ac92dab3ac6f10a15","22":"864e49fd3bee58a35b22","23":"b74d169f8fb1c0e03539","24":"e87ab57fc33333ea4a4e","25":"2567c563c161ae0e2269","26":"700c48982640afbe235e","27":"d2e000edf2cc5068057c","28":"a7e3f277dca3380273de","29":"cbb4873c057851b2cf88","30":"ec72913113eb5d404e6b","31":"13d60e39a4baf9d4016e","32":"0dbd8dce7d01ca7f94c7","33":"c515ea7e612254292629","34":"683b1d217c080fafd180","35":"72ccccb766fee8cd0b72","36":"858738c275e606a66a67","37":"1b664ab05946d9f4fbdd","38":"accae2a70eff21f39813","39":"ef37e544ad92191847ab","40":"fc6e2cb34f0eb9d3ca36","41":"2014dc63ee9fac6f2863","42":"f83d066711dd7f6193b7","43":"fb7885a297c200999e71","44":"bcac4569eee10fc857c4","45":"1d93e6c97b3c74e2958f","46":"c691b06713ccc56fe47a","47":"c4bf2f4bee6382c6239d","48":"99948d6a22fc5a92265e","49":"02182ff09270cbca9966","50":"9f276992815280a48ed6","51":"5b06e2668eec556d52fd","52":"1c200b643bef2771162b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"cb1608f2","2":"styles","3":"44bb9f082193e74168b5135406bf08e32ffb53da","4":"8ccc3ce12924ac33615472e4ecd356ae2961a461","5":"78a9dc6c6428b20d65f489544773ccf386654ce8","6":"5c16e5b16666b7d1dded8a145e379ee02da2efbe","7":"d9c241b54393082e9b9d8418b075aa22f071953c","8":"fcb1787550e3506b9a5b22862ab5d9efe82f78fe","9":"30eb79519e100eace5766eaea1288fe5195dc727","10":"963fcfe0cb6db8fb67219de76b409abdfaf5b68d","11":"ac1c44fc","12":"b6689b9f52a193071338daafc1aa2738f916e04f","13":"c27ef261a850dd77219473b0b3b25ad516ed7add","15":"532a2f07","17":"component---src-pages-404-js","18":"component---src-pages-about-us-js","19":"component---src-pages-bs-404-js","20":"component---src-pages-bs-hvala-vam-js","21":"component---src-pages-bs-impresum-js","22":"component---src-pages-bs-index-js","23":"component---src-pages-bs-kontakt-js","24":"component---src-pages-bs-konzalting-js","25":"component---src-pages-bs-o-nama-js","26":"component---src-pages-bs-reference-js","27":"component---src-pages-bs-well-karijera-js","28":"component---src-pages-consulting-js","29":"component---src-pages-contact-js","30":"component---src-pages-impresum-js","31":"component---src-pages-index-js","32":"component---src-pages-references-js","33":"component---src-pages-thankyou-js","34":"component---src-pages-well-careers-js","35":"component---src-templates-blog-js","36":"component---src-templates-blog-post-js","37":"component---src-templates-bs-blog-js","38":"component---src-templates-bs-blog-post-bs-js","39":"component---src-templates-bs-digitalni-marketing-js","40":"component---src-templates-bs-graficki-dizajn-js","41":"component---src-templates-bs-online-trgovina-js","42":"component---src-templates-bs-portfolio-js","43":"component---src-templates-bs-portfolio-post-bs-js","44":"component---src-templates-bs-video-oglasavanje-js","45":"component---src-templates-bs-web-dizajn-js","46":"component---src-templates-digital-marketing-js","47":"component---src-templates-graphic-design-js","48":"component---src-templates-online-store-js","49":"component---src-templates-portfolio-js","50":"component---src-templates-portfolio-post-js","51":"component---src-templates-video-advertisment-js","52":"component---src-templates-web-design-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"bf85c9848ac48d1c46dc","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
